<template>
  <div class="intro">
    <template v-if="!mobile">
      <div class="star" id="stars"></div>
      <div class="star" id="stars2"></div>
      <div class="star" id="stars3">
        <div v-for="item in 400" :key="item"></div>
      </div>
    </template>
    <div class="intro-content-inner fr-container">
      <div class="content">
        <h2 class="header"><span>Fortchain</span> Stabilize your <span>crypto ride</span></h2>
        <span class="about">
          Welcome to Fortchain. We're a group of professional traders and crypto enthusiasts who thrive to success and will guide you into
          the future of finance, which we're sure will be decentralized, where you can earn passive income through multiple services that we offer.
        </span>
        <div class="down">
          <registration-buttons :hide="1"/>
          <div v-if="false" class="rate">
            <span class="title">See our rates</span>
            <img src="../../../assets/images/arrow-white.png" class="icon" alt="">
          </div>
        </div>
      </div>
      <img src="../../../assets/images/earth.png" class="image" alt="">
    </div>
  </div>
</template>

<script>
import RegistrationButtons from "../../shared/RegistrationButtons";

export default {
  components: {
    RegistrationButtons
  },
  computed: {
    mobile() {
      return window.innerWidth < 1024
    }
  }
}
</script>

<style lang="scss" scoped>
$ease-in-out: cubic-bezier(.27, 0, .18, .99);

.intro {
  margin-top: -187px;
  padding-top: 187px;
  height: 100vh;
  max-height: 100vh;
  background: $base-background;
  overflow: hidden;
  position: relative;
  min-height: 800px;
  @media only screen and (max-width: 1650px) and (min-width: 1366px) {
    margin-top: -152px;
    padding-top: 152px;
    min-height: 750px;
  }
  @media only screen and (max-width: 1365px) and (min-width: 1024px) {
    margin-top: -123px;
    padding-top: 123px;
    min-height: 600px;
  }
  @media only screen and (max-width: 1023px) {
    margin-top: 0;
    padding-top: 100px;
    background: #070A1E;
    max-height: unset;
    height: auto;
  }

  .intro-content-inner {
    display: flex;
    justify-content: space-between;
    padding-right: 150px;
    @media only screen and (max-width: 1650px) and (min-width: 1366px) {
      padding-right: 50px;
    }
    @media only screen and (max-width: 1365px) and (min-width: 1024px) {
      padding-right: 30px;
    }
    @media only screen and (max-width: 1023px) {
      flex-direction: column-reverse;
      padding-right: 20px;
    }
  }

  .content {
    padding-top: 60px;
    width: fit-content;
    @media only screen and (max-width: 1023px) {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 0;
      width: 100%;
    }

    .header {
      color: white;
      font-style: normal;
      font-weight: normal;
      font-size: 80px;
      @media only screen and (max-width: 1650px) and (min-width: 1441px) {
        font-size: 70px;
      }
      @media only screen and (max-width: 1440px) and (min-width: 1366px) {
        font-size: 60px;
      }
      @media only screen and (max-width: 1365px) and (min-width: 1024px) {
        font-size: 42px;
      }
      @media only screen and (max-width: 1023px) {
        font-size: 32px;
        text-align: center;
        span {
          &:first-child {
            display: none;
          }
        }
      }

      span {
        color: $base-color;
        display: block;
        font-weight: 600;
      }
    }

    .about {
      display: block;
      color: white;
      margin-top: 32px;
      font-style: normal;
      line-height: 30px;
      font-weight: 300;
      font-size: 18px;
      max-width: 621px;
      @media only screen and (max-width: 1650px) and (min-width: 1441px) {
        max-width: 550px;
      }
      @media only screen and (max-width: 1440px) and (min-width: 1366px) {
        max-width: 500px;
      }
      @media only screen and (max-width: 1365px) and (min-width: 1024px) {
        margin-top: 20px;
        font-size: 16px;
        max-width: 400px;
      }
      @media only screen and (max-width: 1023px) {
        text-align: center;
        width: 90%;
        font-size: 14px;
        line-height: 22px;
        margin-top: 20px;
      }
    }

    .down {
      @include flex;
      margin-top: 48px;
      @media only screen and (max-width: 1365px) and (min-width: 1024px) {
        margin-top: 32px;
      }
      @media only screen and (max-width: 1023px) {
        margin-top: 20px;
        .sign-in {
          margin-right: 0;
        }
      }

      .title {
        margin-left: 53px;
        color: white;
      }

      .rate {
        @include flex;
        cursor: pointer;
        @media only screen and (max-width: 1023px) {
          display: none;
        }

        .icon {
          margin-left: 10px;
        }
      }

      ::v-deep .registration-button {
        .sign-in {
          margin-left: 0;
        }
      }
    }
  }

  .image {
    border-radius: 50%;
    animation: animEarth 10s linear infinite;
    height: 600px;
    margin-top: 50px;
    @media only screen and (max-width: 1650px) and (min-width: 1441px) {
      height: 500px;
    }
    @media only screen and (max-width: 1440px) and (min-width: 1366px) {
      height: 450px;
    }
    @media only screen and (max-width: 1365px) and (min-width: 1024px) {
      height: 400px;
    }
    @media only screen and (max-width: 1023px) {
      width: 40%;
      height: auto;
      margin: 30px auto;
      animation: unset;
    }
    @media only screen and (max-width: 500px) {
      width: 85%;
    }
  }

  .mobile-image {
    height: 40vh;
    object-fit: contain;
    display: none;
    @media only screen and (max-width: 1023px) {
      display: block;
    }
  }

  @function multiple-box-shadow ($n,$color) {
    $value: '#{random(2000)}px #{random(2000)}px #E4F7FD';
    @for $i from 2 through $n {
      $value: '#{$value} , #{random(2000)}px #{random(2000)}px #{$color}';
    }
    @return unquote($value)
  }


  $shadows-small: multiple-box-shadow(1300, #B4DEF0) ;
  $shadows-medium: multiple-box-shadow(600, #0BB8EA) ;

  .star {
    border-radius: 50%;
    position: absolute;
    @media only screen and (max-width: 1023px) {
      display: none;
    }

    &:after {
      border-radius: 50%;
    }

  }

  #stars {
    width: 1px;
    height: 1px;
    background: transparent;
    box-shadow: $shadows-small;
    animation: animStar 100s linear infinite;

    &:after {
      content: " ";
      position: absolute;
      top: 2000px;
      width: 1px;
      height: 1px;
      background: transparent;
      box-shadow: $shadows-small;
    }
  }

  #stars2 {
    width: 2px;
    height: 2px;
    background: transparent;
    box-shadow: $shadows-medium;
    animation: animStar 150s linear infinite;

    &:after {
      content: " ";
      position: absolute;
      top: 2000px;
      width: 2px;
      height: 2px;
      background: transparent;
      box-shadow: $shadows-medium;
    }

  }

  #stars3 {
    div {
      position: absolute;
      animation: animStar 200s linear infinite;
      background: radial-gradient(50.21% 49.5% at 49.52% 49.86%, #FFFFFF 0%, #F8FDFE 1.84%, #E4F7FD 4.56%, #C3EEFA 7.82%, #96E0F6 11.51%,
          #5CCFF1 15.54%, #16BBEB 19.81%, #0BB8EA 20.43%, #0F97C6 27.88%, #1276A3 36.75%, #155B85 46.15%, #17456F 56.09%, #19375E 66.82%, #1A2E55 78.9%, #1A2B52 95.16%);
      width: 8px;
      height: 8px;
      border-radius: 50%;
      @for $i from 2 through 400 {
        &:nth-child(#{$i}) {
          left: #{random(2000)}px;
          top: #{random(2000)}px;
        }
      }
    }
  }


  @keyframes animStar {
    from {
      transform: translateY(0px)
    }
    to {
      transform: translateY(-2000px)
    }

  }
  @keyframes animEarth {
    0% {
      transform: translateY(0px) perspective(900px) translateX(0) rotatey(0deg);
    }
    30% {
      transform: translateY(-10px) perspective(900px) translateX(10px) rotatey(3deg);
    }
    60% {
      transform: translateY(-15px) perspective(900px) translateX(-15px) rotatey(7deg);
    }
    100% {
      transform: translateY(0) perspective(900px) translateX(0) rotatey(0deg);
    }

  }
  @keyframes animEarthShadow {
    from {
      box-shadow: inset 0 0 62px 20px rgba(60, 105, 138, 0.85);

    }
    to {
      box-shadow: inset 0 0 62px 20px rgba(60, 105, 138, 0.85);
    }

  }
}
</style>